import { Currencies } from '@core/services/currency/currency.service';

import { StoredColumnConfig, UserPreferences } from './user-preferences.model';

/** Legacy localStorage keys migrated once into the backend, then removed. */
export const LEGACY_TABLE_PREFIX = 'customisation-params-table-';
export const LEGACY_CURRENCY_KEY = 'preferred_currency';
export const LEGACY_SOUND_KEY = 'sound_enabled';

export function isEmptyPreferences(prefs: UserPreferences | undefined | null): boolean {
  return Object.keys(prefs ?? {}).length === 0;
}

/** Collects any pre-existing localStorage preferences into a single blob. */
export function collectLegacyPreferences(): UserPreferences {
  const prefs: UserPreferences = {};

  const tables: Record<string, StoredColumnConfig[]> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(LEGACY_TABLE_PREFIX)) {
      const tableId = key.slice(LEGACY_TABLE_PREFIX.length);
      const config = parse<StoredColumnConfig[]>(key);
      if (config) tables[tableId] = config;
    }
  }
  if (Object.keys(tables).length > 0) prefs.tables = tables;

  const currency = localStorage.getItem(LEGACY_CURRENCY_KEY);
  if (currency) prefs.currency = currency as Currencies;

  const sound = parse<boolean>(LEGACY_SOUND_KEY);
  if (sound !== null) prefs.soundEnabled = sound;

  return prefs;
}

/** Removes every legacy preference key from localStorage. */
export function clearLegacyPreferences(): void {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(LEGACY_TABLE_PREFIX)) keys.push(key);
  }
  keys.push(LEGACY_CURRENCY_KEY, LEGACY_SOUND_KEY);
  keys.forEach((key) => localStorage.removeItem(key));
}

function parse<T>(key: string): T | null {
  const raw = localStorage.getItem(key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
